import { render, staticRenderFns } from "./LoyaltyStatusHistoryBlock.vue?vue&type=template&id=6cd58c4c&scoped=true"
import script from "./LoyaltyStatusHistoryBlock.vue?vue&type=script&lang=js"
export * from "./LoyaltyStatusHistoryBlock.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyStatusHistoryBlock.vue?vue&type=style&index=0&id=6cd58c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd58c4c",
  null
  
)

export default component.exports